import { Container, Card } from "@/shared/ui";
import { LinkIcon } from "@/modules/ServiceCore/assets/icons";
import { LEGAL_DOCUMENTS } from "@/modules/Legal/model/legal-documents";
import styles from "./Legal.module.scss";

export function Legal() {
  return (
    <div className={styles.page}>
      <Container>
        <Card className={styles.list}>
          {Object.values(LEGAL_DOCUMENTS).map((doc) => (
            <a
              key={doc.slug}
              className={styles.item}
              href={doc.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className={styles.itemLabel}>{doc.navLabel}</span>
              <LinkIcon />
            </a>
          ))}
        </Card>
      </Container>
    </div>
  );
}
